import {Country} from '../../shared/Models/Country';
import {SystemUser} from '../../shared/Models/SystemUser';

export class DeliveryContact {

  public id: number;
  public companyName: string;
  public address: string;
  public postalCode: string;
  public city: string;
  public country: any;
  public contactPerson: string;
  public email: string;
  public phone: string;
  public isAdvancedCall: boolean;
  public mondayFrom: any;
  public mondayTo: any;
  public tuesdayFrom: any;
  public tuesdayTo: any;
  public wednesdayFrom: any;
  public wednesdayTo: any;
  public thursdayFrom: any;
  public thursdayTo: any;
  public fridayFrom: any;
  public fridayTo: any;
  public deliveryDealer: any;
}
